import ProductComparisonBrand from '@src/quince-site-common/src/domains/ProductComparisonBrand'
import { SERVING_PC_ADDITONAL_ATTRIBUTE_NAME } from '@src/quince-site-common/src/utils/constants'

import AdditionalPropertyComponent from './AdditionalPropertyComponent'
import * as styles from './productPriceComparision.module.scss'

interface ComparisonRowProps {
  isVisible: boolean
  attributeName: string
  productComparisionsBrands: ProductComparisonBrand[]
  servings?: number
  quinceField?: string | number
}

const ComparisonRow = ({ isVisible, attributeName, productComparisionsBrands, quinceField }: ComparisonRowProps) => {
  if (!isVisible) return null
  return (
    <tr className={styles.productPriceComparision__bodyRow}>
      <th className={styles.productPriceComparision__bodyRow__titleCell}>{attributeName}</th>
      <td className={`${styles.productPriceComparision__bodyRow__cell} ${styles.productPriceComparision__firstCell}`}>
        {quinceField}
      </td>
      {productComparisionsBrands.map(br => (
        <td className={styles.productPriceComparision__bodyRow__cell} key={br.brand}>
          <AdditionalPropertyComponent
            additionalProperties={br.additionalProperties}
            apName={attributeName}
            displayRawValue={attributeName === SERVING_PC_ADDITONAL_ATTRIBUTE_NAME}
          />
        </td>
      ))}
    </tr>
  )
}
export default ComparisonRow
